export default __webpack_public_path__ + "static/media/factory__7.a6aa6113.jpg";